export default __webpack_public_path__ + "static/media/epfoValidateOTP@2x.9abecd1a.png";